import { Flex, List, Space, Text, Title,Tooltip } from '@mantine/core';
import { NavLink, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from '@geist-ui/icons';
import { PATHS, dashboardRoutes } from 'src/constants';
import { useTranslation } from 'react-i18next';
import {  useAppSelector } from 'src/store';
import { shallowEqual } from 'react-redux';
import { FC, useEffect, useState } from 'react';
import classNames from 'classnames';
import { useMediaQuery } from '@mantine/hooks';
import Slider from 'react-slick';

import styles from './styles.module.scss';
import './select.css'
import { displayName, wrapText } from 'src/helpers/textWrap';
type ArrowProps = {
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
};

const CustomPrevArrow: FC<ArrowProps> = ({ className, style, onClick }) => {
  return onClick !== null ? (
    <div className={className} style={{ ...style, display: 'block' }} onClick={onClick}>
      <ChevronLeft color="#5b5eff" size={30} />
    </div>
  ) : null;
};

const CustomNextArrow: FC<ArrowProps> = ({ className, style, onClick }) => {
  return onClick !== null ? (
    <div className={className} style={{ ...style, display: 'block' }} onClick={onClick}>
      <ChevronRight color="#5b5eff" size={30} />
    </div>
  ) : null;
};

const DashboardNavBar = (): JSX.Element => {
  const [t] = useTranslation('nav');
  const { id } = useParams();
  const navigate = useNavigate();
  const userIssuesCount = useAppSelector((state) => state.site.data?.userIssuesCount, shallowEqual);
  const selectedSiteData = useAppSelector((state) => state.site.selectedSiteData, shallowEqual);
  const isMobile = useMediaQuery('(max-width: 870px)');
  const splitPath = location.pathname.split('/');
  const activeLinkIndex = dashboardRoutes.findIndex((route) => {
    const path = splitPath[splitPath.length - 1];
    return path === route.path;
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const [siteUUID, setSiteUUID] = useState(searchParams.get('siteUUID'))
  const page = searchParams.get('page')
  const sliderSettings = {
    dots: false,
    infinite: false,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    variableWidth: true,
    initialSlide: activeLinkIndex,
  };
  const getPageNameFromUrl = () => {
    const path = window.location.pathname; // Get the pathname (e.g., /about.html)
    const pageName = path.substring(path.lastIndexOf('/') + 1); // Extract the page name
    return pageName;
  };
  
  useEffect(() => {
    const uuid = searchParams.get('siteUUID');
      setSiteUUID(uuid);
      return;
  }, [searchParams, siteUUID]);

  const [buildlinkSettings, setbuildlinkSettings] = useState('')
  
  useEffect(() => {

    let siteName = selectedSiteData?.label ?? selectedSiteData?.site_name;

    if(!siteName){
       const selectedSite =  JSON.parse(localStorage.getItem('selectedSite') ?? '');
        siteName = selectedSite?.label;
    }
    if(id &&  siteName == id){
      setbuildlinkSettings(`?company=${selectedSiteData?.company_id}&sitedId=${id}`);
      return;
    }
    // case when the site updated with deferent name (id) but the api returns the old one.
    const valueSiteId = selectedSiteData?.value ?? JSON.parse(localStorage.getItem('selectedSite') ?? '')?.id
    if ( valueSiteId != siteUUID  ) { 
      navigate('/dashboard/automated-audit/select');
      return;
    }

  }, [siteUUID])


  

  const pageName = getPageNameFromUrl();

  return (
    <Flex className={styles.navigation} direction="column" justify="space-between" id="main-navigtaion">
      <Flex direction="column" className={styles.innerNavigation} pl={20} pr={28} m={0} py={15}> 
        {
          pageName == "automated-audit" || pageName == "all" ? null :
          <Flex>
            <NavLink to={PATHS.DASHBOARD} className={styles.back}>
              <ChevronLeft color="#5b5eff" />
              <Text>{t('navBack')}</Text>
              <span className={styles['visually-hidden']}>{t('backToDashboard')}</span>
            </NavLink>
          </Flex>
          
        }
        <Title order={1} id={'mainContent'} color='#264547'>
            {
              page ?  page + ' Page' : 'Issues Page ' 
            }
          </Title> 
        <Space h={10} />
        <Flex className={styles.links} justify="space-between" align={'center'} wrap={'wrap'} rowGap={'20px'}>
          
          <Tooltip 
          multiline={true}
          label={wrapText(selectedSiteData?.label ?? selectedSiteData?.site_name)}>
            <Title order={2} tabIndex={-1} className={styles.title}>
            {displayName(selectedSiteData?.label ?? selectedSiteData?.site_name , 30)}
            </Title>
          </Tooltip>
          {isMobile ? (
            <div className={styles['navigation-container']}>
              <div className={styles['slider-container']}>
                <Slider {...sliderSettings} className={classNames(styles.slider, styles.tabs_list_mobile)}>
                  {dashboardRoutes.map((route) => (
                    <div key={route.path} className={styles.item}> 
                      <NavLink to={`${route.path}-${id}/${siteUUID}${buildlinkSettings}#MainAccordion-panel-${siteUUID}`}>
                        {t(`${route.title}`)} {route.key === 'reported' && `(${userIssuesCount || 0})`}
                      </NavLink>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          ) : (
            <List display="flex" pb={15} className={styles.tabs_list}>
              {dashboardRoutes.map((route) => {
                return (
                  <List.Item key={route.path}> 
                    <NavLink to={`${route.path}-${id}/${siteUUID}${buildlinkSettings}#MainAccordion-panel-${siteUUID}`}>
                      {t(`${route.title}`)} {route.key === 'reported' && `(${userIssuesCount || 0})`}
                    </NavLink>
                  </List.Item>
                );
              })}
            </List>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default DashboardNavBar;
